import IProgram from "../../models/Program";
import transformSession from "./session";

const transformProgram = (data: any): IProgram => {
    const program = data.programBatch?.program;

    return {
        id: program?.id ?? 0,
        programBatchId: data.programBatch?.id ?? 0,
        name: program?.program_name ?? "Unnamed Program",
        batchName: data.programBatch?.batch_name ?? "Unnamed Batch",
        category:
            program?.programMeta?.nature_name?.toLowerCase() ?? "other",
        sessions: program?.sessionList?.map((el: any) => transformSession(el)) ?? [],
        batch: {
            id: data.programBatch?.id ?? 0,
            name: data.programBatch?.batch_name ?? "Unnamed Batch",
        },
        myRating: data.programme_rating ?? 0, // default to 0 if not provided
        groupRating: 0, // Replace with actual field if available
        engagement: 0, // Replace with actual field if available
        mode: program?.programMeta?.program_mode?.toLowerCase() ?? "unknown",
        startDate: program?.from_date ?? null,
        endDate: program?.to_date ?? null,
        status: program?.status ?? "Not available",
    };
};

export default transformProgram;
